/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaidPlanDto as FeatureSettingsPaidPlanDto } from '../../models/feature/settings/paid-plan-dto';

export interface GetPaidPlans$Params {
}

export function getPaidPlans(http: HttpClient, rootUrl: string, params?: GetPaidPlans$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureSettingsPaidPlanDto>>> {
  const rb = new RequestBuilder(rootUrl, getPaidPlans.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeatureSettingsPaidPlanDto>>;
    })
  );
}

getPaidPlans.PATH = '/settings/subscription/paid-plans';

